import * as z from 'zod'
import {refineEmail} from '~/design-system/utils'

export const emailFormSchema = z.object({
  email: z.string().refine(...refineEmail),
})
